import { useEffect, useRef } from "react";

/**
 * 「在途集清空/减少」时刷新终态列表(2026-07-25 codex review P2)。
 *
 * ═══ 为什么需要它 ═══════════════════════════════════════════════════════════
 * 「进行中」列表用 `refetchInterval: data.length > 0 ? 5000 : false` 轮询 —— 一旦最后一个
 * 在途任务完成,poll 返回空、轮询**立即停止**,但兄弟的「历史 / 最近作品」列表并没有被
 * invalidate(它有自己的 staleTime,还 fresh 着)。结果:刚完成的任务从「进行中」消失,
 * 却要等下一次无关的 refetch/窗口聚焦才出现在「作品 / 最近作品」—— 中间有一段**两个列表
 * 都看不到它**的空窗。旧仪表盘靠「running 集变化即 invalidate history」避开了这个,重构时漏了。
 *
 * 这个 hook 把「在途数量减少 → 刷新终态列表」收成一处:两个消费点(WorksPage / InFlightRow)
 * 逻辑相同,不各写一遍。
 *
 * @param count   当前在途任务数(减少 = 有任务完成)
 * @param onDrain 在途减少时的回调(通常是 invalidate 终态 query)
 */
export function useRefreshOnDrain(count: number, onDrain: () => void) {
  const prev = useRef(count);
  // 回调放 ref:调用方每次渲染传新箭头函数也不会漏触发、不会因 effect 依赖抖动而重跑
  const cb = useRef(onDrain);
  cb.current = onDrain;
  useEffect(() => {
    if (count < prev.current) cb.current();
    prev.current = count;
  }, [count]);
}
